var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3001 13.4001C16.2309 13.4001 16.1632 13.4206 16.1057 13.4591C16.0481 13.4975 16.0033 13.5522 15.9768 13.6161C15.9503 13.6801 15.9434 13.7505 15.9569 13.8184C15.9704 13.8863 16.0037 13.9486 16.0526 13.9976C16.1016 14.0465 16.164 14.0799 16.2319 14.0934C16.2997 14.1069 16.3701 14.0999 16.4341 14.0734C16.498 14.047 16.5527 14.0021 16.5911 13.9445C16.6296 13.887 16.6501 13.8193 16.6501 13.7501C16.6501 13.6573 16.6133 13.5682 16.5476 13.5026C16.482 13.437 16.393 13.4001 16.3001 13.4001Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3001 10.6001V6.40009",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4733 2.20008C17.3598 1.98755 17.1907 1.80984 16.9841 1.68594C16.7775 1.56203 16.5411 1.49658 16.3001 1.49658C16.0592 1.49658 15.8228 1.56203 15.6162 1.68594C15.4095 1.80984 15.2404 1.98755 15.1269 2.20008L8.04854 15.6919C7.94399 15.8906 7.893 16.1131 7.90061 16.3374C7.90822 16.5618 7.97416 16.7803 8.09194 16.9715C8.21095 17.164 8.37725 17.3228 8.57502 17.4328C8.77278 17.5429 8.99542 17.6004 9.22173 17.6001H23.3785C23.6047 17.6005 23.8272 17.543 24.0249 17.4333C24.2227 17.3235 24.3891 17.165 24.5083 16.9729C24.6261 16.7817 24.692 16.5632 24.6997 16.3388C24.7073 16.1145 24.6563 15.892 24.5517 15.6933L17.4733 2.20008Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7001 21.8H3.70013V26C3.70013 26.3714 3.84763 26.7274 4.11018 26.99C4.37274 27.2526 4.72883 27.4 5.10013 27.4H7.90013C8.64274 27.4 9.35493 27.695 9.88003 28.2202C10.4051 28.7453 10.7001 29.4574 10.7001 30.2C10.7001 30.9427 10.4051 31.6548 9.88003 32.1799C9.35493 32.705 8.64274 33 7.90013 33H3.70013",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 29.5C20.5001 30.4283 20.1314 31.3185 19.475 31.9749C18.8186 32.6313 17.9284 33 17.0001 33C16.0719 33 15.1816 32.6313 14.5252 31.9749C13.8689 31.3185 13.5001 30.4283 13.5001 29.5V25.3C13.5001 24.3718 13.8689 23.4816 14.5252 22.8252C15.1816 22.1688 16.0719 21.8 17.0001 21.8C17.9284 21.8 18.8186 22.1688 19.475 22.8252C20.1314 23.4816 20.5001 24.3718 20.5001 25.3V29.5Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3001 29.5C30.3001 30.4283 29.9314 31.3185 29.275 31.9749C28.6186 32.6313 27.7284 33 26.8001 33C25.8719 33 24.9816 32.6313 24.3252 31.9749C23.6689 31.3185 23.3001 30.4283 23.3001 29.5V25.3C23.3001 24.3718 23.6689 23.4816 24.3252 22.8252C24.9816 22.1688 25.8719 21.8 26.8001 21.8C27.7284 21.8 28.6186 22.1688 29.275 22.8252C29.9314 23.4816 30.3001 24.3718 30.3001 25.3V29.5Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 33.6,
    fill: "white",
    transform: "translate(0.200012 0.0999756)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceUnavailable);
export default __webpack_public_path__ + "static/media/service-unavailable.bbb37d9ffd6b94b284413e6cfbc0e7e6.svg";
export { ForwardRef as ReactComponent };